import {FormHelperText, InputLabel, Option, Select} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import './SelectWidget.css';

const SelectWidget = ({
  id,
  label,
  changeHandler,
  data,
  required = false,
  defaultValue,
  helperText,
  multiple = false,
  hasSelectAll = false,
  disabled = false,
  placeholder,
  value,
  className,
}) => {
  const {t} = useTranslation();
  return (
    <>
      <InputLabel data-testid="select-widget" id="select-label">
        {label} {required && <span className="requiredField">*</span>}
      </InputLabel>
      <Select
        id={id}
        name="select-widget"
        onChange={(e) => changeHandler(e.target.value)}
        multiple={multiple}
        disabled={disabled}
        hasSelectAll={hasSelectAll}
        defaultValue={defaultValue}
        placeholder={placeholder}
        value={value}
        className={className}
        required={true}
      >
        {data
          .filter((i) => (i.hidden ? i.hidden !== true : true))
          .map((item) => {
            return (
              <Option
                value={item.value ? item.value : item}
                key={item.value ? item.value : item}
              >
                {t(item.label ? item.label : item)}
              </Option>
            );
          })}
      </Select>
      {helperText ? (
        <FormHelperText id="helperText" data-testid="helperText">
          {helperText}
        </FormHelperText>
      ) : null}
    </>
  );
};

export default SelectWidget;
